import { defineStore } from 'pinia';

export const useComponentsStore = defineStore('plugins:cms', () =>
{
    const modules = reactive<string[]>([]);
    const widgets = reactive<string[]>([]);

    return { modules, widgets };
});
